module.exports = __webpack_public_path__ + "img/video_play.c74e0c0f.svg";